/**
 * Generate a unique session ID
 */
export const generateSessionId = (): string => {
  const timestamp = Date.now().toString(36)
  const randomStr = Math.random().toString(36).substring(2, 15)
  return `${timestamp}-${randomStr}`
}

/**
 * Get current session ID or create a new one
 */
export const getSessionId = (): string => {
  let sessionId = sessionStorage.getItem('sessionId')
  
  if (!sessionId) {
    sessionId = generateSessionId()
    sessionStorage.setItem('sessionId', sessionId)
  }
  
  return sessionId
}

/**
 * Clear session data
 */
export const clearSession = (): void => {
  sessionStorage.removeItem('sessionId')
  sessionStorage.removeItem('userProfile')
  sessionStorage.removeItem('recommendationResults')
}

/**
 * Store user profile in session
 */
export const storeUserProfile = (profile: any): void => {
  sessionStorage.setItem('userProfile', JSON.stringify(profile))
}

/**
 * Get stored user profile
 */
export const getUserProfile = (): any | null => {
  const stored = sessionStorage.getItem('userProfile')
  return stored ? JSON.parse(stored) : null
}

/**
 * Store recommendation results in session
 */
export const storeRecommendationResults = (results: any): void => {
  sessionStorage.setItem('recommendationResults', JSON.stringify(results))
}

/**
 * Get stored recommendation results
 */
export const getRecommendationResults = (): any | null => {
  const stored = sessionStorage.getItem('recommendationResults')
  return stored ? JSON.parse(stored) : null
}

/**
 * Check if user has completed a recommendation
 */
export const hasCompletedRecommendation = (): boolean => {
  return !!sessionStorage.getItem('recommendationResults')
}